import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";

// Shared by PipelineTable and ScriptVersionsTable, whose "released?" column
// both render the same boolean icon from a DataGrid params.value.
export const renderReleasedIcon = (value) =>
  value + "" === "true" ? (
    <CheckCircleIcon color="success" fontSize="small" />
  ) : (
    <DoNotDisturbIcon color="disabled" fontSize="small" />
  );
